// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '../static/css/weui.css'
import 'vant/lib/index.css';
import '../static/js/aliplayercomponents-1.0.5.min'
import 'babel-polyfill';

import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

// import { emoji } from './assets/js/emoji'
import {
    Uploader,
    Button,
    Popup,
    Dialog
} from 'vant';


import '@/plugin/extendFn'
import './assets/style/common.css'
import extendFn from "./plugin/extendFn"
import waiting from "./plugin/waiting";
import waitingplugin from "@/plugin/waiting/index.js";
// import VConsole from 'vconsole';
// new VConsole()
import store from "./store";

Vue.use(Uploader).use(Button).use(Popup).use(Dialog);

Vue.use(waitingplugin);
Vue.component("waiting", waiting);
// import mui from 'mui'
Vue.prototype.GLOBAL = {
    SOCKETPORT:AppSetting.getSocketPort()
}

import vueSwiper from 'vue-awesome-swiper'

Vue.use(vueSwiper);


import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

Vue.use(preview)
// Vue.prototype.emoji = emoji
Vue.use(extendFn);
import mVueUtils from "./plugin/mVueUtils"
import AppSetting from './AppSetting';

Vue.use(mVueUtils);
Vue.config.productionTip = false
let sUserAgent = navigator.userAgent.toLowerCase();

if (!(/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent))) {

    //跳转移动端页面
    //rem字体
    let origin
    if (!window.location.origin) {
        window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    }
    origin = window.location.origin;

    let pathname = window.location.pathname;
    let search = window.location.search;
    window.location.href = window.location.href.replace('cmdhra_tpl', 'cmdhra_pc');
    
    // if (search.indexOf('?type') != -1) { //说明是详情页面
    //     window.location.href = window.location.href.replace('cmdhra_tpl', 'cmdhra_pc');
    // } else {
    //     let back = `${origin}/cmdhra_pc/`;
    //     window.location.href = back;
    // }
}

const vue= new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");

//设置时间方法
Date.prototype.Format = function (fmt) { //
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
};

//rem字体
document.addEventListener('DOMContentLoaded', function () {
    var html = document.documentElement;
    var windowWidth = html.clientWidth;
    html.style.fontSize = windowWidth / 7.5 + 'px';
}, false);

document.body.addEventListener('focusout', () => {
    setTimeout(() => {
        const scrollHeight =
            document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
    }, 50)
})



export default {
    vue
};



// WEBPACK FOOTER //
// ./src/main.js